import styled from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../../../../components";
import { device } from "../../../../../../services";

export const HistoryLogsWrapper = styled(WrapperContainer)`
  max-height: 64vh;
  overflow-y: auto;
  padding-right: 8px;
  width: 750px;

  @media screen and ${device.laptop} {
    width: 700px;
  }

  @media screen and ${device.tablet} {
    width: 500px;
  }
`;

export const Title = styled(Paragraph2)`
  font-weight: 600;
`;
